module.exports = __webpack_public_path__ + "static/media/ip-preview-premium.82f90ec6.jpg";